import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getLotteries = createAsyncThunk(
  'lotteryTicket/getLotteries',
  async ({ lottery_brand_day_id, skip, limit, draw_date, draw_no, status, is_published }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
        withCredentials: true,
        params: {
          ...(lottery_brand_day_id ? { lottery_brand_day_id } : {}),
          ...(skip ? { skip: skip - 1 } : {}),
          ...(limit ? { limit } : {}),
          ...(draw_date ? { draw_date } : {}),
          ...(draw_no ? { draw_no } : {}),
          ...(status? { status }: {}),
        },
      };

      const response = await axios.get(
        `${PUBLIC_BASE_URL}/lotteries/get-lotteries`,
        config
      );
      return response.data;
    } catch (err) {
      if (err.message === 'Network Error') {
        return rejectWithValue({
          response: {
            data: {
              message: 'Network Error',
              status: err.code,
              statusText: err.code,
            },
          },
        });
      } else {
        return rejectWithValue(
          err.response?.data?.message || 'An error occurred'
        );
      }
    }
  }
);

export const editLotteryInfo = createAsyncThunk(
    'lotteryTicket/editLotteryInfo',
    async (lotteryData, { rejectWithValue }) => {
      try {  
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        };
        
        const body = JSON.stringify(lotteryData);

        const response = await axios.put(
          `${PUBLIC_BASE_URL}/lotteries/update-lottery-info`,
          body,
          config
        );
        return response.data;
      } catch (err) {
        if (err.message === 'Network Error') {
          return rejectWithValue({
            message: 'Network Error',
            status: err.code,
            success: false,
          });
        } else {
          return rejectWithValue(err.response?.data || 'Unknown error occurred.');
        }
      }
    }
  );

  export const viewLotteries = createAsyncThunk(
    'lotteryTicket/viewLotteries',
    async ({ lottery_brand_day_id, skip, limit, draw_date, draw_no }, { rejectWithValue }) => {
      try {
        const config = {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
          params: {
            ...(lottery_brand_day_id ? { lottery_brand_day_id } : {}),
            ...(skip ? { skip: skip - 1 } : {}),
            ...(limit ? { limit } : {}),
            ...(draw_date ? { draw_date } : {}),
            ...(draw_no ? { draw_no } : {}),
          },
        };
  
        const response = await axios.get(
          `${PUBLIC_BASE_URL}/tickets/get-uploaded-tickets`,
          config
        );
        return response.data;
      } catch (err) {
        if (err.message === 'Network Error') {
          return rejectWithValue({
            response: {
              data: {
                message: 'Network Error',
                status: err.code,
                statusText: err.code,
              },
            },
          });
        } else {
          return rejectWithValue(
            err.response?.data?.message || 'An error occurred'
          );
        }
      }
    }
  );